// API URLS
export const COMPETITION_URL = Object.freeze({
    COMPSET: '/api/competition/selector/compset',
    MAIN_HOTEL: '/api/competition/selector/main-hotel',
    MAIN_HOTELS: '/api/competition/selector/main-hotels',
    DATE_RANGE: '/api/competition/selector/date-range-options',
    BOARDS: '/api/competition/selector/boards',
    DEVICES: '/api/competition/selector/devices',
    RATES: '/api/competition/selector/rates',
    SITES: '/api/competition/selector/sites',
    ROOMS: '/api/competition/selector/rooms',
    NIGHTS: '/api/competition/selector/nights',
    PAX: '/api/competition/selector/pax',
    DATA: '/api/competition/data',
    LOCATION_DATA: '/api/competition/location-data',
    PRICE_DETAILS: '/api/competition/price-details',
    SET_OVERVIEW_FILTER: '/api/competition/set-overview-filter',
    MARKET: '/api/competition/selector/markets',
    REPORT_EXECUTION: '/api/competition/selector/id-report-execution',
    EXECUTION_SAVED_FILTERS: '/api/competition/execution/{id}/saved-filters',

    PREVIOUS_DATA: '/api/competition/previous-data',
    PRICE_RANKING: '/api/competition/price-ranking',
    CARDS: '/api/competition/card',
    LAST_UPDATE: '/api/competition/last-date',
    CHART: '/api/competition/chart',
    DAILY_TABLE: '/api/competition/table',
    RATE_COMPARISON: '/api/competition/rate-comparison',
    BOARD_COMPARISON: '/api/competition/board-comparison',
    CALENDAR: '/api/competition/calendar',
    IA_INSIGHTS: '/api/competition/ia/insights',
    MAIL_INSIGHTS: '/api/competition/ia/mail-insights'
})

export const PARITY_URL = Object.freeze({
    DATA: '/api/parity/data',
    DEVICES: '/api/parity/selector/devices',
    DATE_RANGE: '/api/parity/selector/date-range-options',
    NIGHTS: '/api/parity/selector/nights',
    PAX: '/api/parity/selector/pax',
    RATES: '/api/parity/selector/rates',
    SITES: '/api/parity/selector/sites',
    ROOMS: '/api/parity/selector/rooms',
    BOARDS: '/api/parity/selector/boards',
    MAIN_HOTELS: '/api/parity/selector/main-hotels',
    DATA_MAIN_HOTELS: '/api/parity/selector/data-main-hotels',
    SET_OVERVIEW_FILTER: '/api/parity/set-overview-filter',
    MARKET: '/api/parity/selector/markets',
    REPORT_EXECUTION: '/api/parity/selector/id-report-execution',
    EXECUTION_SAVED_FILTERS: '/api/parity/execution/{id}/saved-filters',
    INFO: '/api/parity/selector/info',
    LOCATION_DATA: '/api/parity/location-data',
    BREAKDOWN: '/api/parity/parity-break-down',
    CHAIN_BREAKDOWN: '/api/parity/chain-breakdown',
    CARDS: "/api/parity/card",
    LAST_UPDATE: '/api/parity/last-date',
    CHART: "/api/parity/chart",
    WML_DETAILS: '/api/parity/wml-details',
    WML: "/api/parity/wml",
    SHARE: "/api/parity/share",
    MARKET_BREAKDOWN: "/api/parity/market",
    CHAIN_WML_DETAILS: '/api/parity/chain-wml-details',
    CHAIN_WML: "/api/parity/chain-wml",
    CHAIN_SHARE: "/api/parity/chain-share",
    CHAIN_MARKET_BREAKDOWN: "/api/parity/chain-market",
    BY_DESTINATION: "/api/parity/by-destination",
    CHAIN_CARDS: "/api/parity/chain-card",
    CHAIN_CHART: "/api/parity/chain-chart",
    CHAIN_USERS: "/api/parity/chain-users",
    NA_SEARCHES: "/api/parity/na-searches",
    PRICE_DETAILS: "/api/parity/price-details",
    PREVIOUS_DATA: "/api/parity/previous-data"
})

export const PARITY_BREAKDOWN_TABS = Object.freeze({
    OTA: 'ota',
    META: 'meta',
    CAL: 'calendar',
    DISP: 'disparity',
})

export const  PARITY_GV_TABS = Object.freeze({
    PI: 'Parity Index',
    OP: 'Opportunity cost',
    SE: 'Searches',
})

export const PARITY_IDX_EVOLUTION_TABS = Object.freeze({
    PI: 'pi_',
    OP: 'co_',
    DI: 'diff_',
})

export const PACKAGES_URL = Object.freeze({
    CONFIG: '/api/packages/config',
    MAIN_HOTELS: '/api/packages/selector/main-hotels',
    COMPSET: '/api/packages/selector/compset',
    DATE_RANGE: '/api/packages/selector/date-range-options',
    BOARDS: '/api/packages/selector/boards',
    SITES: '/api/packages/selector/sites',
    ROOMS: '/api/packages/selector/rooms',
    NIGHTS: '/api/packages/selector/nights',
    PAX: '/api/packages/selector/pax',
    ROUTES: '/api/packages/selector/routes',
    MARKET: '/api/packages/selector/markets',
    REPORT_EXECUTION: '/api/packages/selector/id-report-execution',
    EXECUTION_SAVED_FILTERS: '/api/packages/execution/{id}/saved-filters',
    RATES: '/api/packages/selector/rates',
    DATA: '/api/packages/data',

    PRICE_DETAILS: '/api/packages/price-details',
    CARDS: '/api/packages/card',
    LAST_UPDATE: '/api/packages/last-date',
    CALENDAR: '/api/packages/calendar',
    PRICE_RANKING: '/api/packages/price-ranking',
    MIN_PRICE: '/api/packages/table',
    CHART: '/api/packages/chart',
    PREVIOUS_DATA: '/api/packages/previous-data',
})

export const PACKAGES_TABS = Object.freeze({
    MIN_PRICE: 'Min prices',
    PRICE_RANKING: 'Price ranking',
    CALENDAR: 'Prices Calendar'
})

export const HISTORICAL_URL = Object.freeze({
    LOCATION: '/api/historical/selector/location-country',
    CITY: '/api/historical/selector/city-province',
    PROVINCE: '/api/historical/selector/province-country',
    HOTEL_CITY: '/api/historical/selector/hotel-city',
    HOTEL: '/api/historical/selector/hotel-location',
    YEAR: '/api/historical/selector/year',
    RESULTS: '/api/historical/callupon'
})

export const FORM_URL = Object.freeze({
    CURRENCY: '/api/setting/selector/currency-codes',
    TIME_ZONE: '/api/setting/selector/timezone',
    DEVICE: '/api/user-admin/selector/device',
    PAX: '/api/setting/selector/pax',
    LANGUAGE: '/api/setting/selector/language',
    HOTEL: '/api/setting/selector/hotel',
    FREQUENCY: '/api/setting/selector/frequency',
    NIGHTS: '/api/setting/selector/nights',
    LOCATION: '/api/setting/selector/location',
    LOCATION_CATEGORY: '/api/setting/selector/location-category',
    LOCATION_ACCOMMODATION: '/api/setting/selector/location-type-acc',
    PACKAGES_CITY: '/api/setting/selector/packages-city',
    MARKET: '/api/setting/selector/market',
    CLONE: '/api/setting/selector/location',

    COMPSET: Object.freeze({
        HOTEL_SAVE: '/api/setting/hotel/compset/save',
        HOTEL_LIST: '/api/setting/hotel/compset/user/list',
        HOTEL_GET: '/api/setting/hotel/compset/get?id_compset=',
        PACKAGE_SAVE: '/api/setting/packages/compset/save',
        PACKAGE_LIST: '/api/setting/packages/compset/user/list',
        PACKAGE_GET: '/api/setting/packages/compset/get?id_compset=',
    }),

    COMPETITION: Object.freeze({
        SAVE: '/api/setting/hotel/competition/save',
        GET: '/api/setting/hotel/competition/get',
        LIST: '/api/setting/hotel/competition/user/list',
        DELETE: '/api/setting/hotel/competition/delete', 
        SITES: '/api/setting/selector/site/hotel/competition',
        COMPSET: '/api/setting/selector/compset/hotel/competition',
        HOTELS: '/api/setting/hotel/competition/user/hotel/list'
    }),

    PARITY: Object.freeze({
        SAVE: '/api/setting/hotel/parity/save',
        GET: '/api/setting/hotel/parity/get',
        LIST: '/api/setting/hotel/parity/user/list',
        DELETE: '/api/setting/hotel/parity/delete',
        SITES: '/api/setting/selector/site/hotel/parity',
        SET_HOTEL: '/api/session/set-hotel-data-parity'
    }),

    PACKAGES: Object.freeze({
        SAVE: '/api/setting/packages/save',
        GET: '/api/setting/packages/get', 
        LIST: '/api/setting/packages/user/list',
        DELETE: '/api/setting/packages/delete', 
        SITES: '/api/setting/selector/site/packages',
        COMPSET: '/api/setting/selector/compset/packages', 
    }),

    LOCATION_DATA: Object.freeze({
        SAVE: '/api/setting/location/save',
        GET: '/api/setting/location/get',
        LIST: '/api/setting/location/user/list',
        DELETE: '/api/setting/location/delete', 
        SITES: '/api/setting/selector/site/location',
    }),

    GET_USERS: '/api/user-admin/users/get',
    LIST_USERS_MASTER: '/api/user-admin/user/master/list',
    SAVE_USERS_MASTER: '/api/user-admin/user/master/save',
    GET_USERS_MASTER: '/api/user-admin/user/master/get',
    DELETE_USERS: '/api/user-admin/user-list/enable',
    ENABLED_USERS_MASTER: '/api/user-admin/user/enable',
    USERS_SLAVE: '/api/user-admin/selector/users',
    SET_USERS_SLAVE: '/api/session/set-slave',
    SET_HOTEL: '/api/session/set-hotel',
    BI_PANEL_LAYOUT: '/api/session/bi-panel-layout',
    CLAUDE_MESSAGES: '/api/claude/messages',
    GET_SLAVE: '/api/session/user-list-slaves',
    BUILD_SCHEDULERS: '/api/setting/schedulers/build/all',
    CHECK_SETTINGS: '/api/setting/check-setting',
    SAVE_TIMESTAMP: '/api/setting/save-setting-timestamp'
})

const ADMIN_HOTEL_MANAGEMENT_BASE_URL = '/api/admin/hotel/'

export const ADMIN_HOTEL_MANAGEMENT_URL = Object.freeze({
    CHECK_HOTEL: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}check`,
    BOOKING_REFRESH: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}booking-refresh`,
    CLOSED_PERIODS_SAVE: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}closed-periods/save`,
    CLOSED_PERIODS_GET: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}closed-periods/`,
    GET_HOTEL: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}get`,
    SAVE_HOTEL: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}save`,
    USER_HOTEL_SELECTOR: `${ADMIN_HOTEL_MANAGEMENT_BASE_URL}selector/user`,
    CITY_HOTEL_SELECTOR: '/api/user-admin/selector/packages-city',
    USER_HOTEL_SAVE: `/api/admin/hotel-user/save`,
    CITY_HOTEL_SAVE: `/api/admin/hotel-city/save`,
})

export const USER_ADMIN = Object.freeze({
    SAVE_OPTIONS: "/api/setting/options/save",
    SAVE: '/api/setting/user/save',
    GET: '/api/setting/user/get',
    ENABLE: '/api/setting/user/enable',
    LIST: '/api/setting/user/list',
})

export const SESSION_SECURITY_URL = Object.freeze({
    VERIFY_MFA: '/api/session/verify-mfa',
    RESEND_MFA: '/api/session/resend-mfa',
    FORGOT_PASSWORD: '/api/session/forgot-password',
    RESET_PASSWORD: '/api/session/reset-password',
    CHANGE_PASSWORD: '/api/session/change-password',
})

export const ADMIN = Object.freeze({
    USER_CREATION: Object.freeze({
        LIST: "/api/admin/user/list",
        GET: "/api/admin/user/get/",
        SAVE: "/api/admin/user/save",
        ENABLE: "/api/admin/user/enable",
        USER_ACTIVITY_DASHBOARD_SUMMARY: "/api/admin/user/my-users-activity-dashboard/summary",
        USER_ACTIVITY_DASHBOARD_USERS: "/api/admin/user/my-users-activity-dashboard/users",
    }),
    ACCOUNT_MANAGEMENT: Object.freeze({
        LIST: "/api/account-management/list",
        ENABLE: "/api/account-management/enable",
        EMAIL: "/api/account-management/email",
        SLAVES: "/api/account-management/slaves",
    }),
    GLOBAL_USABILITY: Object.freeze({
        SUMMARY:          "/api/admin/usability/summary",
        USERS:            "/api/admin/usability/users",
        HEATMAP:          "/api/admin/usability/heatmap",
        GHOST_USERS:      "/api/admin/usability/ghost-users",
        MODULE_ADOPTION:  "/api/admin/usability/module-adoption",
        ENGAGEMENT_TREND: "/api/admin/usability/engagement-trend",
    }),
    USER_SETTINGS: Object.freeze({
        GET: '/api/setting/user/get',
    }),
    COSTS: Object.freeze({
        USER_LIST: "/api/admin/costs/user-list",
        USER_DETAIL: "/api/admin/costs/user/",
        USER_INVOICE: "/api/admin/costs/user/",
        COMPANY_DETAIL: "/api/admin/costs/company/",
        COMPANY_INVOICE: "/api/admin/costs/company/",
        USER_SELECTOR: "/api/admin/costs/selector/user",
    })
})

export const OVERVIEW = Object.freeze({
    EVENTS: '/api/event/get-month-year',
    EVENTS_UPCOMING: '/api/event/upcoming',
    MAIN_HOTELS: '/api/overview/selector/main-hotels',
    DATE_RANGE: '/api/overview/selector/date-range-options',
    COMPETITION_DATA: '/api/overview/competition/data',
    PARITY_DATA: '/api/overview/parity/data',
    MASTER_COMPETITION_DATA: '/api/overview/competition/chart-data',
    MASTER_PARITY_DATA: '/api/overview/parity/chart-data',
    USER_SITES: '/api/overview/user-sites',
})

export const BANNER = Object.freeze({
    MESSAGES: '/api/banner/messages',
})

export const GLOBAL = Object.freeze({
    CONFIG: '/api/competition/config',
    CONFIG_HOTELS: '/api/user-config/config-hotels',
    CONFIG_PACKAGES: '/api/user-config/config-packages',
    CURRENCY: '/api/user-admin/selector/currency-codes',
    FEATURES: "/api/user-admin/selector/features",
    HOTELS: '/api/user-admin/selector/hotel',
    SITES: '/api/admin/user/selector/site',
    TIMEZONE: " /api/user-admin/selector/timezone",
    FORMAT_DATE: "/api/user-admin/selector/format-date",
    LANGUAGE: "/api/user-admin/selector/language-codes",
    ROLE: "/api/user-admin/selector/role",
    CURRENCY_HEADER: '/api/user-admin/selector/currency-codes-user',
    REFRESH_DATA: '/api/execution/hotel/create/data',
    PACKAGES_REFRESH_DATA: '/api/execution/packages/create/data',
    LOCATION_REFRESH_DATA: '/api/execution/location/create/data',
    STATUS_REFRESH: '/api/execution/hotel/status',
    PACKAGES_STATUS_REFRESH: '/api/execution/packages/status',
    LOCATION_STATUS_REFRESH: '/api/execution/location/status',
    PERCENTAGE_COLOR: '/api/user-config/percentage-color/create',
    LOGIN_HOUSE: '/api/session/login-house',
    DELETE_EVENT: '/api/event/delete',
    MASTER_SLAVES_HOTELS: '/api/user-config/master-slaves-hotels',
    MASTER_SLAVES_SITES: '/api/user-config/master-slaves-sites'
})

export const SESSION = Object.freeze({
    CREATE: '/api/session/dashboard/create',
    LIST: '/api/session/dashboard/list',
    DELETE: '/api/session/dashboard/delete'
})
export const DASHBOARD = Object.freeze({
    COMPETITION: Object.freeze({
        LIST: '/api/dashboard/competition/list',
        SAVE: '/api/dashboard/competition/save',
        EDIT: '/api/dashboard/competition/edit',
        REMOVE: '/api/dashboard/competition/delete',
        GET: '/api/dashboard/competition/get',
    }),
    PARITY: Object.freeze({
        LIST: '/api/dashboard/parity/list',
        SAVE: '/api/dashboard/parity/save',
        EDIT: '/api/dashboard/parity/edit',
        REMOVE: '/api/dashboard/parity/delete',
        GET: '/api/dashboard/parity/get',
    }),
    PACKAGES: Object.freeze({
        LIST: '/api/dashboard/packages/list',
        SAVE: '/api/dashboard/packages/save',
        EDIT: '/api/dashboard/packages/edit',
        REMOVE: '/api/dashboard/packages/delete',
        GET: '/api/dashboard/packages/get',
    })
})

export const FEATURES = Object.freeze({
	COMPETITION: 'competition',
    PARITY: 'parity',
	PACKAGES: 'packages',
    REPORTS: 'reports',
	USER_ADMIN: 'admin-config',
    USER: 'user',
    LOOKER: 'looker',
    BI: 'bi',
    LIST_URL: '/api/feature/list',
    HISTORICAL: 'historical',
    REPORT: 'report',
    REAL_TIME: "real-time",
    ALERTS: 'alert',
    MY_HOTELS: 'my-hotels',
    MY_ROOMS: 'my-rooms',
    MY_USERS: 'my-users',
    ACCOUNT_MANAGEMENT: 'account-management',
    ALERT_LEGACY: 'alert-legacy',
    LOCATION: 'location',
    IA_ASSISTANT: 'ia-assistant',
})

export const USER_ROLE = Object.freeze({
	COMMON: 'user', 
    MASTER: 'master',
	ADMIN: 'admin'
})

export const SCHEDULERS_URL = Object.freeze({
	HOTELS: '/api/scheduler/hotel', 
    LOCATION: '/api/scheduler/location',
	PACKAGES: '/api/scheduler/packages',
    CREATE_HOTEL: '/api/scheduler/hotel/save',
    CREATE_LOCATION: '/api/scheduler/location/save',
	CREATE_PACKAGE: '/api/scheduler/packages/save',
    UPDATE_HOTEL: '/api/scheduler/hotel/get', 
    UPDATE_LOCATION: '/api/scheduler/location/get',
	UPDATE_PACKAGE: '/api/scheduler/packages/get',
    DELETE_HOTEL: '/api/scheduler/hotel/delete', 
    DELETE_LOCATION: '/api/scheduler/location/delete',
	DELETE_PACKAGE: '/api/scheduler/packages/delete',
    ENABLED_HOTEL: '/api/scheduler/hotel/enable',
    ENABLED_LOCATION: '/api/scheduler/location/enable',
    ENABLED_PACKAGES: '/api/scheduler/packages/enable',
    EXECUTE_HOTEL: '/api/search-hotel/scheduler/launch/id_scheduler',
    EXECUTE_LOCATION: '/api/search-location/scheduler/launch/id_scheduler',
    EXECUTE_PACKAGES: '/api/search-packages/scheduler/launch/id_scheduler',
})

export const REPORTS = Object.freeze({
	COMPETITION_SAVE: '/api/competition/export/report/save', 
    COMPETITION_DELETE: '/api/competition/export/report/delete',
	COMPETITION_GET: '/api/competition/export/report/get',
    COMPETITION_LIST: '/api/competition/export/report/list',
    COMPETITION_ENABLE: '/api/competition/export/report/enable',
    PARITY_SAVE: '/api/parity/export/report/save', 
    PARITY_DELETE: '/api/parity/export/report/delete',
	PARITY_GET: '/api/parity/export/report/get',
    PARITY_LIST: '/api/parity/export/report/list',
    PARITY_ENABLE: '/api/parity/export/report/enable',
    PACKAGES_SAVE: '/api/packages/export/report/save', 
    PACKAGES_DELETE: '/api/packages/export/report/delete',
	PACKAGES_GET: '/api/packages/export/report/get',
    PACKAGES_LIST: '/api/packages/export/report/list',
    PACKAGES_ENABLE: '/api/packages/export/report/enable',
})

export const REPORT_SETTINGS = Object.freeze({
    PACKAGES: Object.freeze({
        SAVE: '/api/packages/setting-report/save',
        GET: '/api/packages/setting-report/get', 
        LIST: '/api/packages/setting-report/list',
        DELETE: '/api/packages/setting-report/delete', 
        ENABLED: '/api/packages/setting-report/enable', 
        CITIES: '/api/packages/setting-report/get/packages-city',
        HISTORY: '/api/packages/setting-report/historic',
        EXECUTE: '/wb-report/api/search-packages/report/launch',
        EXECUTION_STATUS: '/api/search-packages/report/execution/status',
        STATUS_PER_SITE: 'api/search-packages/report/execution/status-per-site',
        RETRY: '/api/search-packages/report/retry',
        STOP: '/api/search-packages/report/stop',
        NUM_SEARCHES: '/api/packages/setting-report/count-searches',
        MAIN_HOTELS: '/api/packages/setting-report/selector/main-hotels',
        COMPSET: '/api/packages/setting-report/selector/hotels',
        SITES: '/api/packages/setting-report/selector/sites',
        ROUTES: '/api/packages/setting-report/selector/routes',
        EXCEL_TYPE: '/api/packages/setting-report/selector/excel-type'
    })
})
export const REPORT_SETTINGS_LOCATION = Object.freeze({
    LIST: '/api/setting-report/location/list',
    PERFORM: '/wb-report/api/setting-report/location/execution/launch/',
    STATUS: '/api/setting-report/location/execution/status/',
    STOP: '/api/setting-report/location/execution/stop/',
    FORCE: '/wb-report/api/setting-report/location/export/execution/',
    DETAILS: '/api/setting-report/location/get/',
    DELETE: '/api/setting-report/location/delete/',
    HISTORY: '/api/setting-report/location/execution/historic/',
    SITES: '/api/setting-report/location/selector/sites',
    LOCATION: '/api/setting-report/location/selector/location',
    MAIN_HOTELS: '/api/setting-report/location/selector/main-hotels',
    COMPSET_HOTELS: '/api/setting-report/location/selector/hotels',
    PAX: '/api/setting-report/location/selector/pax',
    NIGHTS: '/api/setting-report/location/selector/nights',
    TYPE_ACCOMMODATION: '/api/setting-report/location/selector/type-accommodation',
    WORKSHEETS: '/api/setting-report/location/selector/worksheets',
    SAVE: '/api/setting-report/location/save',
    COUNT: '/api/setting-report/location/count-searches',
    ENABLE: '/api/setting-report/location/enable',
    STATUS_PER_SITE: '/api/setting-report/location/execution/status-per-site/',
})
export const REPORT_SETTINGS_COMPETITION = Object.freeze({
    LIST: '/api/setting-report/hotel/competition/list',
    PERFORM: '/wb-report/api/setting-report/hotel/execution/launch/',
    STATUS: '/api/setting-report/hotel/execution/status/',
    STOP: '/api/setting-report/hotel/execution/stop/',
    FORCE: '/wb-report/api/setting-report/hotel/export/execution/',
    DETAILS: '/api/setting-report/hotel/competition/get/',
    STATUS_PER_SITE: '/api/setting-report/hotel/execution/status-per-site/',
    DELETE: '/api/setting-report/hotel/competition/delete/',
    HISTORY: '/api/setting-report/hotel/execution/historic/',
    MAIN_HOTELS: '/api/setting-report/hotel/competition/selector/main-hotels',
    SITES: '/api/setting-report/hotel/competition/selector/sites',
    // COMPSET: '/api/setting-report/hotel/competition/selector/hotels',  // replaced by COMPSET_AUTOCOMPLETE
    COMPSET_AUTOCOMPLETE: '/api/setting-report/hotel/competition/selector/hotels/autocomplete',
    PAX: '/api/setting-report/hotel/competition/selector/pax',
    BOARD: '/api/setting-report/hotel/competition/selector/board',
    RATE: '/api/setting-report/hotel/competition/selector/rate',
    ROOM: '/api/setting-report/hotel/competition/selector/room',
    SAVE: '/api/setting-report/hotel/competition/save',
    BULK_SAVE: '/api/setting-report/hotel/competition/bulk-save',
    NIGHTS: '/api/setting-report/hotel/competition/selector/nights',
    WORKSHEETS: '/api/setting-report/hotel/competition/selector/worksheets',
    COUNT: '/api/setting-report/hotel/competition/count-searches',
    ENABLE: '/api/setting-report/hotel/competition/enable/',
    MARKET: '/api/setting-report/hotel/competition/selector/market',
    HOTELS_GROUP: Object.freeze({
        LIST: '/api/group-hotel/hotel/list',
        DELETE: '/api/group-hotel/hotel/delete/',
        SAVE: '/api/group-hotel/hotel/save'
    })
})
export const REPORT_SETTINGS_PARITY = Object.freeze({
    LIST: '/api/setting-report/hotel/parity/list',
    PERFORM: '/wb-report/api/setting-report/hotel/execution/launch/',
    STATUS: '/api/setting-report/hotel/execution/status/',
    STOP: '/api/setting-report/hotel/execution/stop/',
    FORCE: '/wb-report/api/setting-report/hotel/export/execution/',
    DETAILS: '/api/setting-report/hotel/parity/get/',
    STATUS_PER_SITE: '/api/setting-report/hotel/execution/status-per-site/',
    DELETE: '/api/setting-report/hotel/parity/delete/',
    HISTORY: '/api/setting-report/hotel/execution/historic/',
    SITES: '/api/setting-report/hotel/parity/selector/sites',
    // COMPSET: '/api/setting-report/hotel/parity/selector/hotels',  // replaced by COMPSET_AUTOCOMPLETE
    COMPSET_AUTOCOMPLETE: '/api/setting-report/hotel/parity/selector/hotels/autocomplete',
    PAX: '/api/setting-report/hotel/parity/selector/pax',
    BOARD: '/api/setting-report/hotel/parity/selector/board',
    RATE: '/api/setting-report/hotel/parity/selector/rate',
    ROOM: '/api/setting-report/hotel/parity/selector/room',
    SAVE: '/api/setting-report/hotel/parity/save',
    BULK_SAVE: '/api/setting-report/hotel/parity/bulk-save',
    NIGHTS: '/api/setting-report/hotel/parity/selector/nights',
    WORKSHEETS: '/api/setting-report/hotel/parity/selector/worksheets',
    COUNT: '/api/setting-report/hotel/parity/count-searches',
    ENABLE: '/api/setting-report/hotel/parity/enable/',
    MARKET: '/api/setting-report/hotel/parity/selector/market',
    HOTELS_GROUP: Object.freeze({
        LIST: '/api/group-hotel/hotel/list',
        DELETE: '/api/group-hotel/hotel/delete/',
        SAVE: '/api/group-hotel/hotel/save'
    })
})

export const REPORT_SETTINGS_PACKAGES = Object.freeze({
    LIST: '/api/setting-report/packages/list',
    DETAILS: '/api/setting-report/packages/get/',
    DELETE: '/api/setting-report/packages/delete/',
    ENABLE: '/api/setting-report/packages/enable',
    SAVE: '/api/setting-report/packages/save',
    BULK_SAVE: '/api/setting-report/packages/bulk-save',
    COUNT: '/api/setting-report/packages/count-searches',
    PERFORM: '/wb-report/api/setting-report/packages/execution/launch/',
    STATUS: '/api/setting-report/packages/execution/status/',
    STOP: '/api/setting-report/packages/execution/stop/',
    HISTORY: '/api/setting-report/packages/execution/historic/',
    STATUS_PER_SITE: '/api/setting-report/packages/execution/status-per-site/',
    RETRY: '/api/setting-report/packages/execution/retry/',
    FORCE: '/wb-report/api/setting-report/packages/export/execution/',
    BOARD: '/api/setting-report/packages/selector/board',
    RATE: '/api/setting-report/packages/selector/rate',
    ROOM: '/api/setting-report/packages/selector/room',
    PAX: '/api/setting-report/packages/selector/pax',
    NIGHTS: '/api/setting-report/packages/selector/nights',
    /*PACKAGES_CITY: '/api/setting-report/packages/selector/packages-city',*/
    GROUPS: '/api/setting-report/packages/selector/group',
    SITES: '/api/setting-report/packages/selector/sites',
    ROUTES: '/api/setting-report/packages/selector/routes',
    MAIN_HOTELS: '/api/setting-report/packages/selector/main-hotels',
    // COMPSET: '/api/setting-report/packages/selector/hotels',  // replaced by COMPSET_AUTOCOMPLETE
    COMPSET_AUTOCOMPLETE: '/api/setting-report/packages/selector/hotels/autocomplete',
    HOTELS_GROUP: Object.freeze({
        LIST: '/api/group-hotel/packages/list',
        DELETE: '/api/group-hotel/packages/delete/',
        SAVE: '/api/group-hotel/packages/save'
    })
})

export const TAXES = Object.freeze({
	SAVE: '/api/taxes/save',
    DELETE: '/api/taxes/delete',
	GET: '/api/taxes/get',
    LIST: '/api/taxes/list',
    SITES: '/api/user-config/selector/sites',
    HOTELS: '/api/user-config/selector/hotels'
})

export const MARKUP = Object.freeze({
    SAVE: '/api/markup/save',
    DELETE: '/api/markup/delete',
    GET: '/api/markup/get',
    LIST: '/api/markup/list',
    SITES: '/api/user-config/selector/sites',
    HOTELS: '/api/user-config/selector/hotels'
})

export const SURVEY = Object.freeze({
    STATUS: '/api/survey/status',
    ACCEPT: '/api/survey/accept',
    POSTPONE: '/api/survey/postpone',
    COMPLETE: '/api/survey/complete'
})

export const MAPPING = Object.freeze({
    PACKAGES_LIST: '/api/mapping/packages/get',
    PACKAGES_SAVE: '/api/mapping/packages/save',
    HOTELS_LIST: '/api/mapping/hotel/get',
    HOTELS_SAVE: '/api/mapping/hotel/save',
    LOCATION_LIST: '/api/mapping/location/get',
    LOCATION_SAVE: '/api/mapping/location/save',
    SELECT: '/api/mapping/selector/sites',
    SELECT_BY_FEATURE: '/api/mapping/selector/sites-by-feature'
})

export const ALERTS = Object.freeze({
	SAVE: '/api/alert/config/save', 
    DELETE: '/api/alert/config/delete',
	GET: '/api/alert/config/get',
    LIST: '/api/alert/config/list',
    ENABLE: '/api/alert/config/enable',
    EXPORT: '/api/alert/check/export/data',

    TYPES_LIST: '/api/alert/selector/alert-type',
    SITES_LIST: '/api/alert/selector/sites',
    HOTELS_LIST: '/api/alert/selector/hotels',
    COMPETITOR_HOTELS_LIST: '/api/alert/selector/competitor-hotels',
    COMPSET_PRESELECT_LIST: '/api/alert/selector/compset-preselect',
    COMPARISON_LIST: '/api/alert/selector/comparison',
    IKEYS_LIST: '/api/alert/selector/ikey',
    SELECT: '/api/alert/selector/alert',

    NOTIFICATIONS_DATE_RANGE: '/api/alert/notifications/selector/date-range-options',
    NIGHTS: '/api/alert/notifications/selector/nights',
    PAX: '/api/alert/notifications/selector/pax',
    NOTIFICATIONS_SITES: '/api/alert/notifications/selector/sites',
    NOTIFICATIONS_LIST: '/api/alert/notifications/list',
    NOTIFICATIONS_DATE_LIST: '/api/alert/notifications/date/list',
    MONTH_LIST: '/api/alert/notifications/get-month-year',
    COUNT: '/api/alert/notifications/count',

    PARITY_META: '1',
    PARITY_OTA: '2',
    NA_META: '3',
    NA_OTA: '4',
    COMPETITION: '5',
    COMPETITION_NA: '6',
    PACKAGES: '7',
    PACKAGES_NA: '8',
    INFO: '9',

    RATES: 'Rates', 
    AVAILABILITY: 'Availability',
    RATE_CONDITIONS: 'Rate conditions',

    TYPE: Object.freeze({
        COMPETITION: 'competition',
        PARITY_OTA: 'parity-ota', 
        PARITY_META: 'parity-meta',
        PACKAGES: 'packages', 
        RATE_CONDITIONS: 'info'
    })
})

export const REAL_TIME = Object.freeze({
    HOTELS: Object.freeze({
        MARKET: '/api/real-time/hotel/selector/market',
        HOTELS_LIST: '/api/real-time/hotel/selector/hotel/autocomplete',
        SITES_LIST: '/api/real-time/hotel/selector/site',
        GET_SEARCH: '/api/search-hotel/real-time',
        GET_RESULTS: '/api/real-time/hotel/result',
        GET_FORM_DATA_MULTIPLE_SEARCHES: '/api/real-time/hotel/form/id-execution',
        GET_FORM_DATA_SINGLE_SEARCH: '/api/real-time/hotel/form/id-search',
        GET_RESULTS_MULTIPLE_SEARCHES: '/api/real-time/hotel/result/id-execution',
        GET_RESULTS_SINGLE_SEARCH: '/api/real-time/hotel/result/id-search',
        GET_REQUEST: '/api/search-hotel/scraper-request/id_search',
        DOWNLOAD_EXCEL: "/api/search-hotel/export/excel",
    }),
    PACKAGES: Object.freeze({
        HOTELS_LIST: '/api/real-time/packages/selector/hotel/autocomplete',
        SITES_LIST: '/api/real-time/packages/selector/site',
        CITIES_LIST: '/api/real-time/packages/selector/city',
        ROUTES_LIST: '/api/real-time/packages/selector/route',
        GET_FORM_DATA_MULTIPLE_SEARCHES: '/api/real-time/packages/form/id-execution',
        GET_FORM_DATA_SINGLE_SEARCH: '/api/real-time/packages/form/id-search',
        GET_RESULTS_MULTIPLE_SEARCHES: '/api/real-time/packages/result/id-execution',
        GET_RESULTS_SINGLE_SEARCH: '/api/real-time/packages/result/id-search',
        GET_REQUEST: '/api/search-packages/scraper-request/id_search',
        DOWNLOAD_EXCEL: "/api/search-packages/export/excel",
    }),
    LOCATION: Object.freeze({
        LOCATION_LIST: '/api/real-time/location/selector/location/autocomplete',
        SITES_LIST: '/api/real-time/location/selector/site',
        GET_FORM_DATA_MULTIPLE_SEARCHES: '/api/real-time/location/form/id-execution',
        GET_FORM_DATA_SINGLE_SEARCH: '/api/real-time/location/form/id-search',
        GET_RESULTS_MULTIPLE_SEARCHES: '/api/real-time/location/result/id-execution',
        GET_RESULTS_SINGLE_SEARCH: '/api/real-time/location/result/id-search',
        GET_REQUEST: '/api/search-location/scraper-request/id_search',
    })
})

export const RECENT_SEARCHES = Object.freeze({
    HOTEL: Object.freeze({
        LIST: '/api/recent-searches/hotel/list',
        SEARCHES: '/api/recent-searches/hotel/execution',   // + /<id>/searches?date=...
        STATUS: '/api/recent-searches/hotel/execution',     // + /<id>/status
    }),
    PACKAGES: Object.freeze({
        LIST: '/api/recent-searches/packages/list',
        SEARCHES: '/api/recent-searches/packages/execution',
        STATUS: '/api/recent-searches/packages/execution',
    }),
    LOCATION: Object.freeze({
        LIST: '/api/recent-searches/location/list',
        SEARCHES: '/api/recent-searches/location/execution',
        STATUS: '/api/recent-searches/location/execution',
    })
})

export const IAOPTIONS = Object.freeze({
	URL: 'https://price-seeker-app-dot-ia-seeker.ew.r.appspot.com/editDashboard?dashboardId=8ae08241-5dec-4bdc-8bfe-9387b785c075'
})

export const EXECUTION_STATUS = Object.freeze({
    LIST: '/api/user-admin/searches-status/list',
})

export const ADMIN_OFFICIAL_SITE = Object.freeze({
    LIST: '/api/admin/official-site/list',
    SAVE: '/api/admin/official-site/save',
    DELETE: '/api/admin/official-site/delete',
    HOTEL_LIST: '/api/admin/official-site/selector/hotel',
    SITE_LIST: '/api/admin/official-site/selector/config-site'
})

export const ADMIN_CITY = Object.freeze({
    LIST: '/api/admin/city/list',
    GET: '/api/admin/city/get',
    SAVE: '/api/admin/city/save',
    DELETE: '/api/admin/city/delete',
    CHECK_NAME: '/api/admin/city/check-name'
})

export const ADMIN_CITY_MAPPING = Object.freeze({
    LIST: '/api/admin/city-mapping/list',
    SAVE: '/api/admin/city-mapping/save',
    DELETE: '/api/admin/city-mapping/delete',
    SELECTOR_SITE: '/api/admin/city-mapping/selector/site',
    SELECTOR_CITY: '/api/admin/city-mapping/selector/city'
})

export const ADMIN_LOCATION_MAPPING = Object.freeze({
    LIST: '/api/admin/location-mapping/list',
    SAVE: '/api/admin/location-mapping/save',
    DELETE: '/api/admin/location-mapping/delete',
    SELECTOR_SITE: '/api/admin/location-mapping/selector/site',
    SELECTOR_LOCATION: '/api/admin/location-mapping/selector/location'
})

export const ADMIN_LOCATION = Object.freeze({
    SAVE: '/api/admin/location/save',
    CHECK_NAME: '/api/admin/location/check-name'
})

export const W2M_HOTELS_URL = Object.freeze({
    LIST: '/api/admin/w2m-hotel/list',
    SAVE: '/api/admin/w2m-hotel/save',
    DELETE: '/api/admin/w2m-hotel/delete'
})

export const GRANDVALIRA_HOTEL_MAPPING_URL = Object.freeze({
    LIST: '/api/admin/grandvalira-hotel-mapping/list/',
    SAVE: '/api/admin/grandvalira-hotel-mapping/save',
    DELETE: '/api/admin/grandvalira-hotel-mapping/delete',
    SELECTOR_SITE: '/api/admin/grandvalira-hotel-mapping/selector/site'
})

export const GRANDVALIRA_HOTELS_URL = Object.freeze({
    LIST: '/api/admin/grandvalira-hotel/list',
    SAVE: '/api/admin/grandvalira-hotel/save',
    DELETE: '/api/admin/grandvalira-hotel/delete'
})

export const FTP_EXPORT_URL = Object.freeze({
    LIST: '/api/admin/ftp-export',
    CREATE: '/api/admin/ftp-export',
    UPDATE: id => `/api/admin/ftp-export/${id}`,
    DELETE: id => `/api/admin/ftp-export/${id}`,
    SELECTOR_USERS: '/api/admin/ftp-export/selector/users',
    SELECTOR_COMPANIES: '/api/admin/ftp-export/selector/companies',
    SELECTOR_SFTP_USERS: '/api/admin/ftp-export/selector/sftp-users',
    SFTP_CREATE_USER: '/api/sftp-server/create-user',
    SFTP_USERS_LIST: '/api/admin/ftp-export/sftp-users'
})

export const MY_HOTELS_URL = Object.freeze({
    LIST: '/api/my-hotels/list',
    GET: '/api/my-hotels/get/',
    CHECK: '/api/my-hotels/check',
    SAVE: '/api/my-hotels/save',
    UPDATE: '/api/my-hotels/update',
    DELETE: '/api/my-hotels/delete',
    SITES_SELECTOR: '/api/my-hotels/sites-selector',
    ALIAS: '/api/my-hotels/alias',
    MAIN: '/api/my-hotels/main',
    MAPPING_SAVE: '/api/my-hotels/mapping/save',
    CLOSED_PERIODS_SAVE: '/api/my-hotels/closed-periods/save'
})

export const MY_ROOMS_URL = Object.freeze({
    LIST: '/api/room-normalization-custom/list',
    SAVE: '/api/room-normalization-custom/save',
    DELETE: '/api/room-normalization-custom/delete',
    RAWS: '/api/room-normalization-custom/raws',
    SELECTOR_SITES: '/api/room-normalization-custom/selector/sites',
    SELECTOR_HOTELS: '/api/room-normalization-custom/selector/hotels',
    SELECTOR_ROOMS: '/api/room-normalization-custom/selector/rooms',
})

export const ADMIN_SITE = Object.freeze({
    LIST: '/api/admin/site/list',
    FEATURE_STATUS: '/api/admin/site/feature-status'
})

export const IMAGE = Object.freeze({
    ASSETS: 'https://storage.googleapis.com/v4-assets/images',
})

export const FILES = Object.freeze({
    ASSETS: 'https://storage.googleapis.com/v4-assets/files',
})

export const CONFIG_SECTIONS = Object.freeze({
    COMMON_USER: 'Common User',
    MASTER_USER: 'Master User',
    EXECUTION_STATUS: 'Execution status',
    MY_SUSCRIPTION: 'My suscription',
    COMPSET: 'Compset',
    ROOM_MAPPING: 'Room Mapping',
    MAPPING: 'Mapping',
    REPORTS: 'Reports',
    TAXES: 'Taxes',
    ALERTS: 'Alerts',
    NOTIFICATIONS: 'Notifications',
    OFFICIAL_SITE: 'Official site',
    HOTELS_GROUP: 'Hotels Group'
})

export const SCHEDULERS_TABLE_TYPE = Object.freeze({
    HOTEL: 'HOTEL',
    LOCATION: 'LOCATION',
    PACKAGES: 'PACKAGES'
})

export const SITE_STRING_EXCEPTIONS = Object.freeze({
    BOOKING: 'booking.',
    OFFICIAL_SITE: 'Official_Site'
})

export const BEAMER = Object.freeze({
    PRODUCT_ID: 'IcfqcMkK60134'
})

// LIST CONFIG SECTIONS
export const CONFIG_PANEL_SECTIONS = Object.freeze({
    ADMIN_ACCESS: [
        CONFIG_SECTIONS.COMMON_USER, CONFIG_SECTIONS.MASTER_USER, CONFIG_SECTIONS.EXECUTION_STATUS, 
        CONFIG_SECTIONS.MAPPING, CONFIG_SECTIONS.OFFICIAL_SITE
    ],
    USER_ACCESS: [
        CONFIG_SECTIONS.TAXES, CONFIG_SECTIONS.HOTELS_GROUP
    ],
})

export const BOOKING_SITES = Object.freeze({
    APP: 126,
    GENIUS: 163,
    MOBILE: 164,
    COM: 192,
    MX: 352,
    CN: 466,
    BASIC: 473,
    CORE: 498,
    PAY: 556,
    BR: 580,
    PT: 581,
    US: 582,
    UK: 596
})

export const MAX_KEYS_CHART = Object.freeze({
    COMPETITION: 15,
    PARITY: 15,
    PACKAGES: 1000
})

export const REPORT_DATES_OPTIONS = Object.freeze({
	SPECIFIC_DAYS: 'fixed',
	LEAD_TIMES: 'withinDays',
	DAY_WEEK: 'dayWeek',
	RANDOM_MONTH: 'random',
    DAY_SELECTED: 'daysSelected',
    WEEK_SELECTED: 'weekSelected',
    OPTION_SELECTED: 'optionSelected',
    OPTION_SELECTED_FORM: 'rentalDateOption'
})

export const REPORT_STATUS = Object.freeze({
	READY: 'ready',
	RUNNING: 'running',
	GENERATING: 'generating',
	STOPPED: 'stopped',
    FINISHED: 'finished',
    PREPARING: 'preparing',
    NEW: 'new',
    ERROR: 'error',
    NOT_AVAIL: 'not-avail'
})

export const HOTELS_GROUP = Object.freeze({
    LIST: '/api/group-hotel/hotel/list',
    SAVE: '/api/group-hotel/hotel/save',
    DELETE: '/api/group-hotel/hotel/delete/',
    GET: "/api/group-hotel/hotel/get/",
    COMPSET_AUTOCOMPLETE: '/api/group-hotel/hotel/selector/hotels/autocomplete',
    EXPORT_CSV: '/api/group-hotel/hotel/export/csv',
    IMPORT_JPCODES: '/api/group-hotel/hotel/import/jpcodes',
})
export const PACKAGES_GROUP = Object.freeze({
    LIST: '/api/group-hotel/packages/list',
    SAVE: '/api/group-hotel/packages/save',
    DELETE: '/api/group-hotel/packages/delete/',
    GET: '/api/group-hotel/packages/get/',
    MAIN_HOTELS: '/api/group-hotel/packages/selector/main-hotels',
    COMPSET: '/api/group-hotel/packages/selector/hotels',
    COMPSET_AUTOCOMPLETE: '/api/group-hotel/packages/selector/hotels/autocomplete',
    SELECT: '/api/packages/setting-report/selector/group',
    SAVE_GROUP_REPORT_NAME: '/api/packages/setting-report/edit-group',
    EXPORT_CSV: '/api/group-hotel/packages/export/csv',
    IMPORT_JPCODES: '/api/group-hotel/packages/import/jpcodes',
})

export const CACHE = Object.freeze({
    CLEAR: '/api/clear-cache',
})

export const ADMIN_MENU = Object.freeze({
    USER_MANAGEMENT: {
        label: 'User Management', i18nKey: 'navigation:admin.userManagement',
        route: '/admin-user-management',
        admin: true,
        icon: 'users'
    },
    USER_COST: {
      label: 'User Cost', i18nKey: 'navigation:admin.userCost',
      route: '/admin-user-cost',
      admin: true,
      icon: 'chart-line'
    },
    /*COMMON_USER: {
        label: 'User Settings',
        route: '/admin-user-settings',
        admin: true,
        icon: 'user-cog'
    },
    MASTER_USER: {
        label: 'Master User',
        route: '/admin-master-user',
        admin: true,
        icon: 'user-shield'
    },*/
    EXECUTION_STATUS: {
        label: 'Execution status', i18nKey: 'navigation:admin.executionStatus',
        route: '/admin-execution-status',
        admin: true,
        icon: 'tasks'
    },
    SEARCH_CONTROL: {
        label: 'Search Control', i18nKey: 'navigation:admin.searchControl',
        route: '/admin-search-control',
        admin: true,
        icon: 'calendar-check'
    },
    MAPPING: {
        label: 'Mapping', i18nKey: 'navigation:admin.mapping',
        route: '/admin-mapping',
        admin: true,
        icon: 'map'
    },
    OFFICIAL_SITE: {
        label: 'Official site', i18nKey: 'navigation:admin.officialSite',
        route: '/admin-official-site',
        admin: true,
        icon: 'globe'
    },
    SITE_MANAGEMENT: {
        label: 'Site Management', i18nKey: 'navigation:admin.siteManagement',
        route: '/admin-site-management',
        admin: true,
        icon: 'server'
    },
    HOTELS: {
        label: 'Hotels Management', i18nKey: 'navigation:admin.hotelsManagement',
        route: '/admin-hotels',
        admin: true,
        icon: 'hotel'
    },
    CITY_MAPPING: {
        label: 'City Mapping', i18nKey: 'navigation:admin.cityMapping',
        admin: true,
        icon: 'map-marker-alt',
        children: [
            { label: 'Packages', i18nKey: 'navigation:admin.cityMappingPackages', route: '/admin-city-mapping' },
            { label: 'Locations', i18nKey: 'navigation:admin.cityMappingLocations', route: '/admin-location-mapping' }
        ]
    },
    TAXES: {
        label: 'Taxes', i18nKey: 'navigation:admin.taxes',
        route: '/config-taxes',
        admin: false,
        icon: 'percentage'
    },
    MARKUP: {
        label: 'Markup', i18nKey: 'navigation:admin.markup',
        route: '/config-markup',
        admin: false,
        icon: 'tags'
    },
    PACKAGES_GROUP: {
        label: 'Packages Group', i18nKey: 'navigation:admin.packagesGroup',
        route: '/config-packages-group',
        admin: false,
        icon: 'city',
        features: ['packages']
    },
    HOTELS_GROUP: {
        label: 'Hotels Group', i18nKey: 'navigation:admin.hotelsGroup',
        route: '/config-hotels-group',
        admin: false,
        icon: 'city',
        features: ['competition', 'parity']
    },
    MY_HOTELS: {
        label: 'My Hotels', i18nKey: 'navigation:admin.myHotels',
        route: '/my-hotels',
        admin: false,
        icon: 'hotel',
        feature: 'my-hotels'
    },
    MY_ROOMS: {
        label: 'My Rooms', i18nKey: 'navigation:admin.myRooms',
        route: '/my-rooms',
        admin: false,
        icon: 'bed'
    },
    MY_USERS: {
        label: 'My Users Activity Dashboard', i18nKey: 'navigation:admin.myUsersActivity',
        route: '/my-users-activity-dashboard',
        icon: 'users',
        feature: 'my-users',
    },
    MY_ACCOUNTS: {
        label: 'Account Management', i18nKey: 'navigation:admin.myAccounts',
        route: '/my-accounts',
        icon: 'user-cog',
        feature: 'account-management',
    },
    GRANDVALIRA_HOTELS: {
        label: 'Grandvalira Hotels', i18nKey: 'navigation:admin.grandvaliraHotels',
        route: '/admin-grandvalira-hotels',
        admin: true,
        icon: 'mountain'
    },
    W2M_HOTELS: {
        label: 'W2M Hotels', i18nKey: 'navigation:admin.w2mHotels',
        route: '/admin-w2m-hotels',
        admin: true,
        icon: 'hotel'
    },
    HOTEL_MERGE: {
        label: 'Hotel Merge', i18nKey: 'navigation:admin.hotelMerge',
        route: '/admin-hotel-merge',
        admin: true,
        icon: 'code-branch'
    },
    FTP_EXPORT: {
        label: 'FTP Export', i18nKey: 'navigation:admin.ftpExport',
        route: '/admin-ftp-export',
        admin: true,
        icon: 'file-export'
    },
    GLOBAL_USABILITY: {
        label: 'Platform Usability', i18nKey: 'navigation:admin.globalUsability',
        route: '/admin-global-usability',
        admin: true,
        icon: 'chart-network'
    },
})